import classNames from 'classnames';
import mainStyles from '../../skeletons.module.scss';
import styles from './row-skeleton.module.scss';

type Props = {
  height?: number;
  rowNumber?: number;
};

const RowSkeleton = ({ height = 17, rowNumber = 1 }: Props) => {
  return (
    <>
      {Array(rowNumber)
        .fill(null)
        .map<React.ReactNode>((_, index: number) => (
          <div
            key={index}
            className={classNames(mainStyles.gradient, styles.row)}
            style={{ height, width: '100%' }}
          />
        ))}
    </>
  );
};

RowSkeleton.displayName = 'RowSkeleton';

export default RowSkeleton;
